import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
var _AppHelper;
import EventEmitter from 'events';
var instance = null;
EventEmitter.defaultMaxListeners = 100;
export var AppHelper = /*#__PURE__*/function (_EventEmitter) {
  function AppHelper(config) {
    var _this;
    _this = _EventEmitter.call(this) || this;
    instance = _this;
    Object.assign(_this, config);
    return _this;
  }
  _inheritsLoose(AppHelper, _EventEmitter);
  var _proto = AppHelper.prototype;
  _proto.get = function get(key) {
    return this[key];
  };
  _proto.set = function set(key, val) {
    var _this2 = this;
    if (typeof key === 'string') {
      this[key] = val;
    } else if (typeof key === 'object') {
      Object.keys(key).forEach(function (item) {
        _this2[item] = key[item];
      });
    }
  };
  _proto.batchOn = function batchOn(events, listener) {
    var _this3 = this;
    if (!Array.isArray(events)) return;
    events.forEach(function (event) {
      return _this3.on(event, listener);
    });
  };
  _proto.batchOnce = function batchOnce(events, listener) {
    var _this4 = this;
    if (!Array.isArray(events)) return;
    events.forEach(function (event) {
      return _this4.once(event, listener);
    });
  };
  _proto.batchOff = function batchOff(events, listener) {
    var _this5 = this;
    if (!Array.isArray(events)) return;
    events.forEach(function (event) {
      return _this5.off(event, listener);
    });
  };
  return AppHelper;
}(EventEmitter);
_AppHelper = AppHelper;
AppHelper.getInstance = function () {
  if (!instance) {
    instance = new _AppHelper();
  }
  return instance;
};